// extracted by mini-css-extract-plugin
export default {"tableWrapper":"AuditSummary_tableWrapper__AxVec"};